import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { useRef } from 'react';
import { useMenu, useMenuItem, useFocusRing, mergeProps } from 'react-aria';
import { useTreeState, Item as CollectionItem } from 'react-stately';

import { motion } from '../../theme/motion';
import { theme } from '../../theme/theme';

export const MenuItem = CollectionItem;

export function Menu(props) {
  const menuRef = useRef();
  const treeState = useTreeState({ ...props, selectionMode: 'none' });
  const menu = useMenu(props, treeState, menuRef);

  return (
    <MenuContainer {...menu.menuProps} ref={menuRef}>
      {[...treeState.collection].map((item) => {
        return <Item key={item.key} item={item} treeState={treeState} onAction={props.onAction} />;
      })}
    </MenuContainer>
  );
}

function Item({ item, treeState, onAction }) {
  const itemRef = useRef();

  const menuItem = useMenuItem(
    {
      key: item.key,
      isDisabled: item.props.isDisabled,
      onAction: item.props.onAction ?? onAction,
    },
    treeState,
    itemRef,
  );

  const focusRing = useFocusRing();

  return (
    <MenuItemContainer
      {...mergeProps(menuItem.menuItemProps, focusRing.focusProps)}
      ref={itemRef}
      data-is-focus-visible={focusRing.isFocusVisible}
      isDisabled={item.props.isDisabled}
      warning={item.props.warning}
    >
      {item.rendered}
    </MenuItemContainer>
  );
}

const MenuContainer = styled.ul`
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  list-style: none;
`;

const MenuItemContainer = styled.li`
  ${getBackgroundColor};
  padding: 0;
  outline: 0;
  border-radius: ${theme.borderRadius.default};
  transition: ${motion.transition.micro};
`;

function getBackgroundColor({ isDisabled, warning }) {
  const highlightColor =
    !isDisabled && warning ? theme.color.danger_background : theme.color.background_hover;

  return css`
    opacity: ${isDisabled ? 0.2 : 1};
    cursor: ${isDisabled ? 'not-allowed' : 'pointer'};

    &:hover {
      background-color: ${highlightColor};
    }

    &[data-is-focus-visible='true'] {
      outline: 2px solid ${theme.color.focus_ring};
    }
  `;
}
